import FilterButton from "common/components/ui/FilterButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";
import { PAGE_SIZE_OPTIONS } from "common/constants";

interface PageSizeSelectorProps {
  pageSize: number;
  setPageSize: (newPageSize: number) => void;
}

export default function PageSizeSelector({
  pageSize,
  setPageSize,
}: PageSizeSelectorProps) {
  return (
    <div className="flex items-center gap-x-1">
      <span className="text-button-xs text-black-500 max-md:hidden">
        Items per page:
      </span>

      <Select
        value={pageSize.toString()}
        onValueChange={(newValue) => setPageSize(Number(newValue))}
      >
        <SelectTrigger asChild>
          <FilterButton size="sm">
            <SelectValue />
          </FilterButton>
        </SelectTrigger>

        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((option) => (
            <SelectItem value={option.toString()} key={option}>
              <SelectItemText>{option}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
